import { createFileRoute, redirect } from '@tanstack/react-router';
import type { PermissionsResponseDTO } from '@tempo-io/id-dto';

export const loopIndexBeforeLoad = async ({
  params: { org, loopId },
  context,
}: {
  params: { org: string; loopId: number };
  context: { permissions: Partial<PermissionsResponseDTO> };
}) => {
  const to = context.permissions.edit_planner
    ? '/org/$org/loop/$loopId/portfolio'
    : '/org/$org/loop/$loopId/strategy';
  throw redirect({
    to,
    params: { org, loopId },
    replace: true,
  });
};

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/')({
  beforeLoad: loopIndexBeforeLoad,
});
